import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import copy from 'copy-to-clipboard';
import { Button } from '@ontruck/orc';

import style from './style.module.scss';

class CopyButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  render() {
    const { children, className, feedbackSuccess, leftIcon, getText, ...others } = this.props;

    /**
     *  NOTICE: This used to be an async method that requested the messages
     *  and copied them to the clipboard.
     *
     *  However, browsers only allow you to document.execCommand('copy')
     *  i.e. copy to the clipboard upon a real user action (e.g. a click).
     *
     *  You can ONLY copy text to the clipboard in the very event handler
     *  that handles the click, not in any async callback.
     *
     *  As suck we need to load the messages first (when you open the modal)
     *  and only copy them later. This sucks and is probably riddled with
     *  unexpected behavior if the network is down or the server slow.
     */
    const requestCopy = (event) => {
      event.preventDefault();
      if (this.state.copied) {
        return;
      }

      getText().then((c) => copy(c));

      this.setState({ copied: true }, () => {
        setTimeout(() => this.setState({ copied: false }), 5000);
      });
    };

    const disabled = !getText;
    const copied = this.state.copied;

    return (
      <div>
        <Button
          disabled={copied || disabled}
          onClick={requestCopy}
          className={cx(className, {
            [style.success]: copied,
          })}
          leftIcon={copied ? 'check' : leftIcon}
          iconClassName={style.doneIcon}
          {...others}
        >
          {copied ? feedbackSuccess : children}
        </Button>
      </div>
    );
  }
}

CopyButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  feedbackSuccess: PropTypes.any,
  leftIcon: PropTypes.string,
  getText: PropTypes.func,
};

export default CopyButton;
